export default __webpack_public_path__ + "static/abipraya-3a6d73e7c3ab3cb9233aeae60b0453db.webp";